/**
 * Generic string utilities.
 */

export function padLeft (value, size, char) {
  var pad   = ''
  var string = `${ value }`

  while (pad.length < size) {
    pad += char
  }

  return pad.substring(0, pad.length - string.length) + string
}

export function pluralize (count, singular, plural) {
  return Math.abs(count) === 1 ? singular : plural
}

export function timerize (value) {
  let minutes = value / 60 | 0
  let seconds = value % 60

  return padLeft(minutes, 2, '0') + ':' + padLeft(seconds, 2, '0')
}



/** WEBPACK FOOTER **
 ** ./web/static/lib/strings.js
 **/